import React, {useCallback, useEffect, useState} from "react";
import * as apiCalls from '../../ApiCalls';
import * as yup from 'yup'
import {alertConstants} from "../../constants";
import {Field, Form, Formik} from "formik";
import {
  Container, Row, Col, CardGroup, Card, CardBody, Input,
  InputGroup, InputGroupAddon, InputGroupText, Button
  // @ts-ignore
} from 'reactstrap';
import AlertMessage from "../AlertMessage/AlertMessage";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {useHistory, useLocation} from "react-router-dom";

const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

function PasswordReset() {
  const history = useHistory();
  const location = useLocation<{ alertMsgs?: AlertMessageType[] }>();

  const [alerts, setAlerts] = useState<AlertMessageType[]>([]);
  const user: any = useSelector((state: RootState) => state.authentication.user);

  useEffect(() => {
    setAlerts(location.state?.alertMsgs ?? []);
  }, [location.state?.alertMsgs]);

  const updatePassword = useCallback((values: { password: string, passwordConfirm: string }) => {
    apiCalls.updatePassword(user.username, values.password)
      .then((response) => {
        if (response.success) {
          addAlert({ msg: 'Password has been updated successfully.', type: alertConstants.SUCCESS });
          history.push('/trends');
        } else {
          addAlert({ msg: response.errMsg, type: alertConstants.ERROR });
        }
      })
      .catch((err) => {
        addAlert({ msg: `Failed to update password. ${err.message}`, type: alertConstants.ERROR });
      })
  }, [history, user.username]);

  const passwordSchema = yup.object({
    password: yup.string().trim()
      .min(8, "Invalid Password - Minimum 8 characters")
      .matches(PASSWORD_REGEX, "Invalid Password - Must contain at least one letter, one number and one special character (@, $, !, %, *, #, ?, &)")
      .required("Password is required"),
    passwordConfirm: yup.string().trim()
      .oneOf([yup.ref('password')], 'Password does not match')
      .required('Required')
  });

  function addAlert(message: AlertMessageType) {
    setAlerts((a) => a.concat(message));
  }

  return (
    <Formik validationSchema={passwordSchema} onSubmit={updatePassword}
            initialValues={{ password: '', passwordConfirm: '' }}>
      <div className={'app flex-row align-items-center'}>
        <Container>
          <Row className={'justify-content-center'}>
            {alerts.map((a, index) => <AlertMessage key={index} {...a} />)}
          </Row>
          <Row className={'justify-content-center'}>
            <Col md={8}>
              <CardGroup>
                <Card className={'p-4'}>
                  <CardBody>
                    <Form>
                      <Row className={'reset-pw-row'}>
                        <Col xs={9}>
                          <h3>Reset your password</h3>
                        </Col>
                      </Row>
                      <Field name={'password'} component={({ field, form }: any) => (
                        <InputGroup className={'mb-4'}>
                          <InputGroupAddon addonType={'prepend'}>
                            <InputGroupText>
                              <i className={'icon-lock'} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input type={'password'} {...field} invalid={form.errors.password && form.touched.password} />
                          {form.errors.password && form.touched.password && (
                            <div className={'full-width'}>{form.errors.password}</div>
                          )}
                        </InputGroup>
                      )} />
                      <Field name={'passwordConfirm'} component={({ field, form }: any) => (
                        <InputGroup className={'mb-4'}>
                          <InputGroupAddon addonType={'prepend'}>
                            <InputGroupText>
                              <i className={'icon-lock'} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input type={'password'} {...field} invalid={form.errors.passwordConfirm && form.touched.passwordConfirm} />
                          {form.errors.passwordConfirm && form.touched.passwordConfirm && (
                            <div className={'full-width'}>{form.errors.passwordConfirm}</div>
                          )}
                        </InputGroup>
                      )} />
                      <Row>
                        <Col />
                        <Col xs={'auto'}>
                          <Button type={'submit'} color={'primary'} className={'px-4'}>Update Password</Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    </Formik>
  )
}

export default PasswordReset;
